module.exports = __webpack_public_path__ + "img/portfolio-04.f8f1b37f.jpg";